import { createFileRoute } from '@tanstack/react-router';

import { OwnStockPage } from '@/features/subcontracts/purchases-page';

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/own-stock')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <OwnStockPage projectId={projectId} />;
}
